<mat-card appearance="outlined" [formGroup]="formGroup" *ngIf="isPersonalLoan === false">
  <mat-card-header>
    <mat-card-title>ABN/ACN details</mat-card-title>
    <mat-card-subtitle>Please enter an ABN or ACN of the business applying for this facility</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-8">
        <fmc-abn-search
          [parentFormGroup]="formGroup"
          [controlName]="'abnAcnNumber'"
          [placeholderText]="'ABN / ACN search'"
          (abnResults)="selectAbnRecord($event)"
        ></fmc-abn-search>
      </div>
    </div>

    <div class="row" *ngIf="!formGroup.get('abnAcnAvailable').value">
      <div class="col-sm-12">
        <p>
          <mat-checkbox formControlName="abnAcnConfirmation">I confirm that I hold an application form and privacy consent
            signed by all company directors and/or individuals.
          </mat-checkbox>
        </p>
        <mat-error>
          <app-validation-partial
            [formGroup]="formGroup"
            [fieldName]="'abnAcnConfirmation'"
          ></app-validation-partial>
        </mat-error>
      </div>
    </div>
  </mat-card-content>
</mat-card>
